/* eslint-disable @typescript-eslint/no-explicit-any */
// To parse this data:
//
//   import { Convert, UserRequest } from "./file";
//
//   const response = Convert.toUserRequest(json);

export interface UserRequest {
  PaginationToken?: any;
  UsersWithGroups: UsersWithGroup[];
}
export interface ListUsersInGroupResponse {
  NextToken?: string;
  Users: User[];
}
export interface UsersWithGroup {
  User?: User;
  Groups?: Group[];
}
export interface SingleUserWithGroup {
  User?: SingleUser;
  Groups?: Group[];
}
export enum Group {
  FlightPathAdmin = 'FlightPathAdmin',
  AccountOwner = 'AccountOwner',
  Admins = 'Admin',
  Users = 'User',
  Managers = 'Manager',
  Planners = 'Planner',
  Operators = 'Operator',
  Dealers = 'Dealer'
}

export interface User {
  Attributes: Attribute[];
  Enabled: boolean;
  MFAOptions: any[];
  UserCreateDate: Date;
  UserLastModifiedDate: Date;
  Username: string;
  UserStatus: UserStatus;
}

export interface SingleUser {
  UserAttributes: Attribute[];
  Enabled: boolean;
  MFAOptions: any[];
  UserCreateDate: Date;
  UserLastModifiedDate: Date;
  Username: string;
  UserStatus: UserStatus;
}
export interface FlatUser {
  Enabled: boolean;
  UserCreateDate: Date;
  UserLastModifiedDate: Date;
  Username: string;
  UserStatus: string;
  EmailVerified: boolean;
  Email: string;
  Groups: Group[];
  SelectedGroup: string;
  DisplayGroups: string;
}

export interface Attribute {
  Name: string;
  Value: string;
}

export interface UserStatus {
  Value: string;
}
// Converts JSON strings to/from your types
export class Convert {
  public static toUserRequest(json: string): UserRequest {
    return JSON.parse(json);
  }
  public static toUsersWithGroup(json: string): UsersWithGroup {
    return JSON.parse(json);
  }
  public static toSingleUsersWithGroup(json: string): SingleUserWithGroup {
    return JSON.parse(json);
  }
  public static userRequestToJson(value: UserRequest): string {
    return JSON.stringify(value);
  }
  public static toListUsersInGroupResponse(json: string): ListUsersInGroupResponse {
    return JSON.parse(json);
  }
}
